// extracted by mini-css-extract-plugin
var _1 = "editCardContainer__vU5ia";
export { _1 as "editCardContainer" }
